import React from "react";
import classes from "./pdpShimmer.module.scss";

const ShimmerLine = ({ className }) => (
  <div className={`${classes.shimmer_line} ${className || ""}`} />
);

const PdpShimmer = ({ image, name, price, symbol }) => {
  return (
    <>
      <div className={classes.pdp_shimmer}>
        {/* Mobile Image */}
        <div className="d-lg-none">
          <div className={classes.image_slider}>
            <div
              className={`${classes.image_placeholder} ${!image ? classes.shimmer_line : ""}`}
            >
              {image && <img src={image} alt={name || "Product"} />}
            </div>
          </div>
        </div>

        <div className={classes.shimmer_container}>
          {/* Breadcrumb */}
          <div className={classes.breadcrumb}>
            <ShimmerLine className={classes.breadcrumb_item} />
            <ShimmerLine className={classes.breadcrumb_separator} />
            <ShimmerLine className={classes.breadcrumb_current} />
          </div>

          <div className={classes.detail_wrapper}>
            {/* Desktop Image Grid */}
            <div className={`${classes.image_section} d-none d-lg-block`}>
              <div className={classes.image_grid}>
                {[0, 1, 2, 3].map((i) => (
                  <div key={i} className={classes.image_grid_item}>
                    <div
                      className={`${classes.image_placeholder} ${!image ? classes.shimmer_line : ""}`}
                    >
                      {image && i === 0 && (
                        <img src={image} alt={name || "Product"} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Product Details */}
            <div className={classes.product_details}>
              {/* Title */}
              {name ? (
                <p className={classes.product_name}>{name.toUpperCase()}</p>
              ) : (
                <>
                  <ShimmerLine className={classes.product_title} />
                  <ShimmerLine className={classes.product_title_short} />
                </>
              )}

              {/* SKU + Rating */}
              <div className={classes.sku_row}>
                <ShimmerLine className={classes.sku} />
                <ShimmerLine className={classes.rating} />
              </div>

              {/* Price Section */}
              <div className={classes.price_section}>
                <div className={classes.price_row}>
                  <div>
                    {price ? (
                      <p className={classes.price_real}>
                        {symbol}{" "}
                        {new Intl.NumberFormat("en-IN", {
                          style: "decimal",
                        }).format(price)}
                      </p>
                    ) : (
                      <ShimmerLine className={classes.price} />
                    )}
                    <ShimmerLine className={classes.price_sub} />
                  </div>
                  <ShimmerLine className={classes.price_breakup} />
                </div>
                <ShimmerLine className={classes.note} />
              </div>

              {/* Color Options */}
              <div className={classes.color_section}>
                <ShimmerLine className={classes.section_label} />
                <div className={classes.color_options}>
                  {[0, 1, 2].map((i) => (
                    <ShimmerLine key={i} className={classes.color_circle} />
                  ))}
                </div>
              </div>

              {/* Size Options */}
              <div className={classes.size_section}>
                <div className={classes.section_header}>
                  <ShimmerLine className={classes.section_label} />
                  <ShimmerLine className={classes.size_guide} />
                </div>
                <div className={classes.size_options}>
                  {[0, 1, 2, 3, 4].map((i) => (
                    <div key={i} className={classes.size_item}>
                      <ShimmerLine className={classes.size_box} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Quantity */}
              <div className={classes.quantity_section}>
                <ShimmerLine className={classes.section_label} />
                <ShimmerLine className={classes.counter} />
              </div>

              {/* Pincode */}
              <div className={classes.pincode_section}>
                <ShimmerLine className={classes.section_label} />
                <ShimmerLine className={classes.input} />
              </div>

              {/* Desktop Action Buttons */}
              <div className={`${classes.action_buttons} d-none d-md-flex`}>
                <ShimmerLine className={classes.btn} />
                <ShimmerLine className={classes.btn} />
              </div>

              {/* Fair Pricing */}
              <div className={classes.fair_pricing}>
                <div className={classes.fair_header}>
                  <ShimmerLine className={classes.fair_title} />
                  <ShimmerLine className={classes.learn_more} />
                </div>
                <div className={classes.fair_row}>
                  <ShimmerLine className={classes.label} />
                  <ShimmerLine className={classes.value} />
                </div>
                <div
                  className={`${classes.fair_row} ${classes.fair_row_border}`}
                >
                  <ShimmerLine className={classes.label} />
                  <ShimmerLine className={classes.value} />
                </div>
              </div>

              {/* Description placeholder */}
              <div className={classes.description_section}>
                <ShimmerLine className={classes.desc_line} />
                <ShimmerLine className={classes.desc_line} />
                <ShimmerLine className={classes.desc_line} />
                <ShimmerLine className={classes.desc_line} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile fixed bottom buttons */}
      <div className={`${classes.mobile_buttons} d-sm-none`}>
        <ShimmerLine className={classes.mobile_btn} />
        <ShimmerLine className={classes.mobile_btn} />
      </div>
    </>
  );
};

export default PdpShimmer;
